/**
 * One name per screen.
 *
 * The home tile, the page title and the back button all read from here, so a
 * screen cannot be called "Suivi" in one place and "Commandes" in another.
 */

export const SCREEN_LABELS: Record<string, string> = {
  "/": "Accueil",
  "/commandes": "Suivi",
  "/commandes-ouvertes": "Commandes ouvertes",
  "/commandes-recurrentes": "Commandes récurrentes",
  "/commandes-en-lot": "Nouveau listing",
  "/commandes-listing": "Nouveau listing",
  "/clients": "Clients",
  "/abonnements": "Abonnements",
  "/evenements": "Évènements",
  "/preparations": "Mes tâches",
  "/validations-abonnements": "Validations atelier",
  "/achats-fleurs": "Achats fleurs",
  "/mes-taches": "Mes tâches",
  "/calendrier": "Calendrier",
  "/conges": "Congés payés",
  "/livraisons": "Livraisons",
  "/gestion-livraisons": "Gestion des livraisons",
  "/medias": "Photos",
  "/equipe": "Équipe",
  "/verifications": "Vérifications",
  "/parametres": "Paramètres",
  "/catalogue": "Catalogue",
  "/catalog": "Catalogue",
  "/caisses": "Caisses",
  "/statistiques": "Statistiques",
  "/stats": "Statistiques",
};

/** Label for a pathname, matching the longest registered prefix. */
export function screenLabel(pathname: string): string | null {
  if (SCREEN_LABELS[pathname]) return SCREEN_LABELS[pathname];
  const match = Object.keys(SCREEN_LABELS)
    .filter((path) => path !== "/" && pathname.startsWith(path))
    .sort((a, b) => b.length - a.length)[0];
  return match ? SCREEN_LABELS[match] : null;
}
